export default __webpack_public_path__ + "static/1-home-page-592bedc02a90bdaf8cc94ff8bafbf6fc.jpg";